
import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import AboutPage from '../pages/about/page';
import ServicesPage from '../pages/services/page';
import PortfolioPage from '../pages/portfolio/page';
import ContactPage from '../pages/contact/page';
import BlogPage from '../pages/blog/page';
import ServiceAreasPage from '../pages/service-areas/page';
import AIAssessmentPage from '../pages/tools/ai-assessment/page';
import ROICalculatorPage from '../pages/tools/roi-calculator/page';
import NotFoundPage from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/about',
    element: <AboutPage />
  },
  {
    path: '/services',
    element: <ServicesPage />
  },
  {
    path: '/portfolio',
    element: <PortfolioPage />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: '/blog',
    element: <BlogPage />
  },
  {
    path: '/service-areas',
    element: <ServiceAreasPage />
  },
  {
    path: '/tools/ai-assessment',
    element: <AIAssessmentPage />
  },
  {
    path: '/tools/roi-calculator',
    element: <ROICalculatorPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
